import Big from "big.js";
import { purchaseIntentConstant } from "./constant";
import { PurchaseIntentBig, PurchaseIntent } from "./types";

export const makeOneNumberScore = (topPercent: Big, secondPercent: Big): Big => {
	return topPercent.mul(purchaseIntentConstant.top).add(secondPercent.mul(purchaseIntentConstant.second)).mul(100);
};

export const changeNumberPurchaseIntent = (purchaseIntent: PurchaseIntentBig): PurchaseIntent => {
	const { topBox, secondBox, top2Box, score, sampleSize } = purchaseIntent;
	return {
		topBox: topBox.toNumber(),
		secondBox: secondBox.toNumber(),
		top2Box: top2Box.toNumber(),
		score: score.toNumber(),
		sampleSize: sampleSize.toNumber(),
	};
};

export const changeBigPurchaseIntent = (purchaseIntent: PurchaseIntent): PurchaseIntentBig => {
	const { topBox, secondBox, top2Box, score, sampleSize } = purchaseIntent;
	return {
		topBox: new Big(topBox),
		secondBox: new Big(secondBox),
		top2Box: new Big(top2Box),
		score: new Big(score),
		sampleSize: new Big(sampleSize),
	};
};
